import { Navbar } from "../../components/navbar"
import { homeWorkData } from "../../json/HomeWorkData"
import { Footer } from "../../components/footer";
import { Collab } from "../../components/collab";
import { useScroll, useTransform, motion } from "framer-motion";
import { LogoForProjects } from "../../components/logoForProjects";
import { ProjectDescription } from "../../components/ProjectDescription";

const wipBanner = [
    { id: 1 },
    { id: 2 },
    { id: 3 },
    { id: 4 },
    { id: 5 },
    { id: 6 },
    { id: 7 },
    { id: 8 },
    { id: 9 },
    { id: 10 },
    { id: 11 },
    { id: 12 },
]

export const WorkWave = () => {
    const findProjectByTitle = (title) => (
        homeWorkData.find(project => project.title === title)
    )

    const project = findProjectByTitle("WorkWave")
    // console.log(project);

    // WIP Props:
    const { scrollYProgress } = useScroll()
    const x = useTransform(scrollYProgress, [0, 1], [0, -2500])

    return (
			<>
				<Navbar />
				<section className="px-[16px] md:px-[32px] lg:px-[192px] bg-[#C0D8D7] pb-[4rem] font-jakarta">
					<LogoForProjects />
					<div className="flex flex-col mt-[4rem] md:mt-[5rem] gap-[1rem] md:gap-[1rem]">
						<div className="flex gap-[0.5rem]">
							<div className="py-[0.5rem] px-[1rem] bg-[#E0FD60] text-[#002921] w-max rounded-full font-medium text-[16px] md:text-[17px]">
								Selected Work
							</div>
							<div className="py-[0.5rem] px-[1rem] bg-[#002921] text-white w-max rounded-full font-normal text-[16px] md:text-[17px]">
								Work in Progress
							</div>
						</div>
						<h1 className="text-[3.5rem] md:text-[5rem] font-medium text-[#002921] tracking-tight leading-none">
							{project.title}
						</h1>
					</div>
				</section>
				<section className="px-[8px] md:px-[32px] lg:px-[192px] bg-[#C0D8D7] rounded-b-2xl pb-[10px] md:pb-[32px]">
					<img
						src={project.imgData[0]}
						alt=""
						className="rounded-2xl w-full object-cover"
					/>
				</section>
				{/* Desc */}
				<ProjectDescription props={project} /> 
				<div>
					<section className="flex items-center gap-[3rem] md:gap-[6rem] overflow-hidden bg-gradient-to-b from-[#FCFCFC] to-[#ebf3f3] pt-[9rem] pb-[12rem] md:pb-[15rem]">
						{wipBanner.map((item) => (
							<motion.div
								style={{ x }}
								className="font-jakarta flex flex-col justify-center text-[#001713] text-[3rem] odd:italic odd:font-thin md:text-[4.75rem] leading-none tracking-tighter"
							>
								<span>Work in</span>
								<span>Progress</span>
							</motion.div>
						))}
					</section>
				</div>
				{/* Images */}
				{/* <section className="px-[16px] md:px-[32px] lg:px-[192px] bg-[#FCFCFC] pt-[1.5rem] pb-[8rem] md:pb-[9rem] flex flex-col gap-[0.75rem] md:gap-[1.25rem]">
                <img src={img3} alt="" className="rounded-lg w-full" />
                <img src={img2} alt="" className="rounded-lg w-full" />
                <div className="grid grid-cols-1 md:grid-cols-2 gap-[0.75rem] md:gap-[1.25rem]">
                    <img src={img1} alt="" className="cols-span-1 rounded-lg h-full object-cover" />
                    <img src={img4} alt="" className="cols-span-1 rounded-lg h-full object-cover" />
                </div>
                <img src={img5} alt="" className="rounded-lg w-full" />
            </section> */}
				<Collab />
				<Footer />
			</>
		);
}